export default {
      id: "group-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#group",
      toString: function () {
        return this.url;
      }
    }